import { render, staticRenderFns } from "./SortingList.vue?vue&type=template&id=423a63b1&scoped=true&"
import script from "./SortingList.vue?vue&type=script&lang=js&"
export * from "./SortingList.vue?vue&type=script&lang=js&"
import style0 from "./SortingList.vue?vue&type=style&index=0&id=423a63b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a63b1",
  null
  
)

export default component.exports